import React from 'react';
import { Grid } from '@mui/material';
import { ButtonWrapper } from '../layout/button-wrapper';
import { buttonStyles } from '../../constants/theme/styles/components/buttonstyles';
import { WysiwygWithReactLink } from '../wysiwyg-with-react-link';
import { FieldAutomationIds } from '../../constants/field-automation-ids';

let submitting = false;

interface FormButtonProps {
    submitText: string;
    cancelText: string;
    onCancel: () => any;
    onSubmit: () => any;
    disabled: boolean;
    submitDisabled?: boolean;
    hideCancelButton?: boolean;
    helperText?: string;
    altCancelButton?: boolean;
    flexEnd?: boolean;
}

export function FormButtons(props: FormButtonProps) {

    const buttonClasses = buttonStyles();

    function HandleOnClick(event){
        if (!submitting){
            submitting = true;           
           
            props?.onSubmit();           

            setTimeout(() => {
                submitting = false;                
            }, 1000);
        } else {
            event?.preventDefault();            
        }
    }

    return (
        <>
            <ButtonWrapper flexEnd={props.flexEnd}>
                <>
                    {
                        !props.hideCancelButton &&
                        <button type='button' data-testid={FieldAutomationIds.formCancelButton} className={props.altCancelButton ? buttonClasses.secondaryButton : buttonClasses.tertiaryButton} disabled={props.disabled} onClick={props.onCancel}>{props.cancelText}</button>
                    }
                    <button type='submit' className={buttonClasses.primaryButton} data-testid={FieldAutomationIds.formSubmitButton} onClick={(event)=>HandleOnClick(event)} disabled={props.disabled || props.submitDisabled} >{props.submitText}</button>                                        
                </>
            </ButtonWrapper>
            {props.helperText &&
                <div className='grid-main-content'><Grid container direction="row" justifyContent="flex-end"><Grid
                justifyContent="flex-end"
                container
                    item md={6}><WysiwygWithReactLink content={props.helperText} />
            </Grid></Grid></div>}
        </>
    );
}

FormButtons.defaultProps = {
    submitDisabled: false,
    hideCancelButton: false,
    altCancelButton: false,
    flexEnd: true,
    helperText: '',
};
